import { Operation } from '../../../__generated__/globalTypes'

import {
  ItemCategoryFragment,
  itemCategoryFragmentString,
} from '../../fragments/__generated__/ItemCategoryFragment'

import { sendDelayFragmentString } from '../../fragments/__generated__/SendDelayFragment'

import { itemFragmentString } from '../../fragments/__generated__/ItemFragment'

import { giftVariationFragmentString } from '../../fragments/__generated__/GiftVariationFragment'

import { amountString } from '../../fragments/__generated__/Amount'

import { priceString } from '../../fragments/__generated__/Price'

import getItemCategoriesRawString from '../GetItemCategories.graphql'

const getItemCategoriesString = [
  getItemCategoriesRawString,
  itemCategoryFragmentString,
  sendDelayFragmentString,
  itemFragmentString,
  giftVariationFragmentString,
  amountString,
  priceString,
].join('\n\n')

export type GetItemCategoriesData = {
  itemCategories: (ItemCategoryFragment & {
    children: ItemCategoryFragment[]
  })[]
}

export type GetItemCategories = Operation<GetItemCategoriesData>

export const GetItemCategories = (): GetItemCategories => ({
  query: getItemCategoriesString,
  variables: undefined,
})
